import { DataProvider } from 'react-admin'
import {
  DataProviderMethodResponse,
  throwNotSupported
} from '../../../dataProvider'
import { getProducts } from '../repository/getProducts'
import { Product } from '../hooks/useDigitalOrders'

export const digitalOrdersProvider: DataProvider = {
  getList: async (_resource, params) => {
    const response = await getProducts(params)

    if ('error' in response) {
      throw new Error(response.error)
    }

    const total = response.total_entries
    const data = response.products.map(parseDigitalProducts)
    const meta = response.has_batches_regardless_filters

    return { data, total, meta } as DataProviderMethodResponse
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: throwNotSupported,
  deleteMany: throwNotSupported
}

const parseDigitalProducts = (product: Product) => {
  return {
    id: product.id,
    name: product.name,
    total_items_count: product.total_items_count
  }
}
